module.exports = __webpack_public_path__ + "img/demo10.952ba6f1.jpg";